import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
export default {
  searchPartStoreList(URL, header, success, error) {
    Vue.axios.get(URL + 'orderplan/psflist', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getPartlinkage(URL, header, success, error) {
    Vue.axios.get(URL + 'orderplan/partlinkage', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  // Order Release
  getOrderRelease(URL, header, success, error) {
    Vue.axios.get(URL + 'orderplan/orderrelease', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getExportList(URL, header, success, error) {
    Vue.axios.get(URL + 'orderplan/exportlist', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  // Order Release
  releaseProcess(URL, obj, header, success, error) {
    Vue.axios.post(URL + 'orderplan/releaseprocess', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getReleaseRound(URL, header, success, error) {
    Vue.axios.get(URL + 'orderplan/releaseround', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  rmOrder(URL, ord_id, header, success, error) {
    Vue.axios.delete(URL + 'orderplan/' + ord_id, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getDockList(URL, header, success, error) {
    Vue.axios.get(URL + 'orderplan/docklist', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getCycleList(URL, header, success, error) {
    Vue.axios.get(URL + 'orderplan/cyclelist', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getSupplierList(URL, header, success, error) {
    Vue.axios.get(URL + 'orderplan/supplierlist', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
  //   getIssueDetailList(URL, cdcl_id, header, success, error) {
  //     Vue.axios.get(URL + 'orderplan/issuedetaillist/' + cdcl_id, header).then(
  //       response => {
  //         success(response.data)
  //       },
  //       response => {
  //         error(response)
  //       }
  //     )
  //   },
  //   addIssueDetailCycle(URL, obj, header, success, error) {
  //     Vue.axios.post(URL + 'orderplan/issuedetail', obj, header).then(
  //       response => {
  //         success(response.data)
  //       },
  //       response => {
  //         error(response)
  //       }
  //     )
  //   },
  //   // Order Release Export
  //   getIssueList(URL, header, success, error) {
  //     Vue.axios.get(URL + 'orderplan/issuelist', header).then(
  //       response => {
  //         success(response.data)
  //       },
  //       response => {
  //         error(response)
  //       }
  //     )
  //   },
}



// WEBPACK FOOTER //
// ./src/models/orderplan.js